//
// Tabs
// @https://getbootstrap.com/docs/5.2/getting-started/javascript/#using-bootstrap-as-a-module
//

import { Tab } from '../../../../../../node_modules/bootstrap/dist/js/bootstrap.esm'

function init() {
  Array.from(document.querySelectorAll('.ce-tabs')).forEach(node => new Tab(node));
}

export default {};

export const Init = init;
